export default "./dist/stdassets/images/icons/zoom-full.png";